/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import Component from "@glimmer/component";
let ICD10Dropdown = (_class = class ICD10Dropdown extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "icd10", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
  }
  get suggestionsForFur() {
    const suggestions = this.icd10.suggestedIcd10ForFur(this.args.patient.followUpReason);

    /**
     * If there are no suggested ICD10 codes for the current
     * patient's FuR, don't filter the suggestions array
     */
    if (!suggestions.length) return suggestions;
    const existingComorbidities = this.args.changeset.get("comorbidities");
    const existingIgnoredComorbidities = this.args.changeset.get("ignoredComorbidities");

    /**
     * If there are existing comorbidities or ignored comorbidities
     * for the current patient, don't filter the suggestions array
     */
    if (!existingComorbidities && !existingIgnoredComorbidities.length) return suggestions;

    /**
     * Filter the suggestions if some have already been ignored
     * or added to the comorbidity list
     */
    return suggestions.reduce((acc, curr) => {
      if (existingComorbidities?.includes(curr) || existingIgnoredComorbidities.includes(curr)) {
        return acc;
      }
      acc.push(curr);
      return acc;
    }, []);
  }
  addSuggestedComorbidity(icd10Code, event) {
    const comorbidities = this.args.changeset.get("comorbidities") ? [...this.args.changeset.get("comorbidities")] : [];
    comorbidities.push(icd10Code);
    this.args.changeset.set("comorbidities", comorbidities);
    event.preventDefault();
  }
  ignoreSuggestedComorbidity(icd10Code, event) {
    const ignoredComorbidities = this.args.changeset.get("ignoredComorbidities") ? [...this.args.changeset.get("ignoredComorbidities")] : [];
    ignoredComorbidities.push(icd10Code);
    this.args.changeset.set("ignoredComorbidities", ignoredComorbidities);
    event.preventDefault();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "icd10", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "addSuggestedComorbidity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addSuggestedComorbidity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ignoreSuggestedComorbidity", [action], Object.getOwnPropertyDescriptor(_class.prototype, "ignoreSuggestedComorbidity"), _class.prototype), _class);
export { ICD10Dropdown as default };